import { track } from '../lib/analytics';

type FabProps = {
  onClick: () => void;
};

export default function ChatFAB({ onClick }: FabProps) {
  const handleClick = () => {
    track('assistant_open', {
      assistant_trigger: 'fab',
      element_label: 'Chat FAB',
      section_name: 'floating',
    });
    onClick();
  };

  return (
    <button type="button" onClick={handleClick} aria-label="Open the GrihaTEK assistant" aria-expanded={false} style={{ display: 'flex', position: 'fixed', right: 22, bottom: 22, zIndex: 60, width: 62, height: 62, borderRadius: '50%', border: '1px solid rgba(201,143,61,.55)', background: '#201F1D', boxShadow: '0 8px 28px rgba(32,31,29,.38)', cursor: 'pointer', alignItems: 'center', justifyContent: 'center', transition: 'transform .18s ease' }}>
      <svg viewBox="0 0 40 40" width={32} height={32} fill="none" role="img" aria-label="GrihaTEK assistant mark: a chat bubble with signal arcs">
        <path d="M20 4 C11 4 4 10.5 4 18.5 C4 23 6.2 27 9.7 29.5 L8 36 L15.5 32.3 C17 32.7 18.5 33 20 33 C29 33 36 26.5 36 18.5 C36 10.5 29 4 20 4 Z" stroke="#FAF9F7" strokeWidth={2.2} strokeLinejoin="round" />
        <circle cx={20} cy={24} r={2.2} fill="#C98F3D" />
        <path d="M15.76 19.76 A6 6 0 0 1 24.24 19.76" stroke="#C98F3D" strokeWidth={2.4} strokeLinecap="round" style={{ animation: 'gt-arc 2.4s ease-in-out 0s infinite' }} />
        <path d="M12.93 16.93 A10 10 0 0 1 27.07 16.93" stroke="#C98F3D" strokeWidth={2.4} strokeLinecap="round" style={{ animation: 'gt-arc 2.4s ease-in-out .25s infinite' }} />
      </svg>
    </button>
  );
}
